import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['display', 'form', 'input', 'value'];
  static values = {
    url: String,
  };

  connect() {
    this.formTarget.classList.add('hide');
    this.displayTarget.classList.remove('hide');
  }

  edit(event) {
    if (event) {
      event.preventDefault();
    }

    this.hideAllForms();

    this.formTarget.classList.remove('hide');
    this.displayTarget.classList.add('hide');
    this.inputTarget.focus();
    this.inputTarget.select();
  }

  cancel(event) {
    if (event) {
      event.preventDefault();
    }

    this.displayTarget.classList.remove('hide');
    this.formTarget.classList.add('hide');
    this.inputTarget.value = this.valueTarget.textContent.trim();
  }

  async save(event) {
    if (event) {
      event.preventDefault();
    }

    if (!this.hasInputTarget) {
      return;
    }

    const url = this.urlValue;
    if (!url) {
      return;
    }

    const formData = this.serializeFormData();

    this.setLoadingState(true);

    try {
      const response = await fetch(url, {
        method: 'PATCH',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': this.getCsrfToken(),
          Accept: 'application/json',
        },
        body: formData,
      });

      const data = await response.json();

      if (response.ok && data.success) {
        this.updateValue(data.plate_number);
        if (data.message && typeof toastr !== 'undefined') {
          toastr.success(data.message);
        }
      } else {
        if (data.message && typeof toastr !== 'undefined') {
          toastr.error(data.message);
        }
      }
    } catch (error) {
      if (typeof toastr !== 'undefined') {
        toastr.error('Wystąpił błąd podczas zapisywania. Spróbuj ponownie.');
      }
    } finally {
      this.setLoadingState(false);
    }
  }

  handleKeydown(event) {
    if (event.key === 'Enter' || event.keyCode === 13) {
      event.preventDefault();
      this.save();
    }

    if (event.key === 'Escape' || event.keyCode === 27) {
      event.preventDefault();
      this.cancel();
    }
  }

  serializeFormData() {
    const formData = new FormData();
    formData.append('form_data[plate_number]', this.inputTarget.value.trim());
    return formData;
  }

  getCsrfToken() {
    const token = document.querySelector('meta[name="csrf-token"]');
    return token ? token.getAttribute('content') : '';
  }

  setLoadingState(loading) {
    const saveButton = this.formTarget.querySelector('[data-action*="inline-edit#save"]');

    if (saveButton) {
      if (loading) {
        saveButton.disabled = true;
        saveButton.classList.add('loading');
      } else {
        saveButton.disabled = false;
        saveButton.classList.remove('loading');
      }
    }

    this.inputTarget.disabled = loading;
  }

  hideAllForms() {
    document.querySelectorAll('[data-controller~="inline-edit"]').forEach((controller) => {
      const displayElement = controller.querySelector('[data-inline-edit-target="display"]');
      const formElement = controller.querySelector('[data-inline-edit-target="form"]');

      if (displayElement) {
        displayElement.classList.remove('hide');
      }

      if (formElement) {
        formElement.classList.add('hide');
      }
    });
  }

  updateValue(newValue) {
    this.valueTarget.textContent = newValue;
    this.cancel();
  }

  disconnect() {}
}
